import { createAction, props } from '@ngrx/store';
import { SalesProductPrice } from '../../uig-product.models';

export const getProductPrice = createAction(
    '[Custom Get Product Price] get product price',
    props<{
        productCode: string;
    }>()
  );

export const getProductPriceSuccess = createAction(
    '[Custom Get Product Price] get product price success',
    props<{ updateProductPrice: SalesProductPrice }>()
);

export const getProductPriceFailure = createAction(
    '[Custom Get Product Price] get product price failure',
    props<{ error: Error }>()
);

// *****************************************************

export const updateProductPrice = createAction(
    '[Custom Update Product Price] update product price',
    props<{
        bestPrice: string;
        productCode: string;
        userCustomUvpPrice: string;
        userCustomProfitMarginPercent: string;
        taxm1: number;
    }>()
  );

export const updateProductPriceSuccess = createAction(
    '[Custom Update Product Price] update product price success',
    props<{ updateProductPrice: SalesProductPrice }>()
);

export const updateProductPriceFailure = createAction(
    '[Custom Update Product Price] update product price failure',
    props<{ error: Error }>()
);